var client = {
	data () {
		return {
			objectClient: {
				id: 0,
				name: '',
				surname: '',
				number_document: '',
				birthdate: '',
				email: '',
				phone: '',
				token: '',
				type_client_id: 0,
				client_sendto_id: null,
				client_sendto: {},
				extras: {},
				address: [],
				created_at: '',
				updated_at: ''
			}
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		checkTokenClient(token) {
			this.searchingToken = true
			this.errorToken = false

			let url = this.getApiBackend + 'client/checkToken'
			let data = {token: token}

			this.axiosLocal('POST', url, 'checkTokenClientResult', data)
		},
		checkTokenClientResult(response) {
			this.checkTokenClientResultLocal(response)
		},
		checkTokenClientResultLocal(response) {
			console.log('checkTokenClientResultLocal no desarrllado', response)
		},
		clearObjectClient() {
			this.objectClient.id = 0
			this.objectClient.name = ''
			this.objectClient.surname = ''
			this.objectClient.number_document = ''
			this.objectClient.birthdate = ''
			this.objectClient.email = ''
			this.objectClient.phone = ''
			this.objectClient.token = ''
			this.objectClient.type_client_id = 0
			this.objectClient.client_sendto_id = null
			this.objectClient.client_sendto = {}
			this.objectClient.extras = {}
			this.objectClient.address = []
			this.objectClient.created_at = ''
			this.objectClient.updated_at = ''
		},
		setObjectClient(item) {
			for (const property in item) {
				this.objectClient[property] = item[property]
			}
		},
	},
}

export default client;